import { useNavigate } from 'react-router';
import { useEffect, useState } from 'react';
import { IDashboardDrawBudget } from '@apply/api/src/api/DrawApi';
import { DrawApi } from '@apply/api';
import { isMobileScreen } from '@apply/ui';

interface DrawAddressLinkProps {
    dashboardDrawBudget: IDashboardDrawBudget;
    set_modalDashboarDrawBudget: React.Dispatch<React.SetStateAction<DrawApi.IDashboardDrawBudget | undefined>>;
}

export const DrawAddressLink: React.FC<DrawAddressLinkProps> = ({ dashboardDrawBudget, set_modalDashboarDrawBudget }) => {
    const navigate = useNavigate();

    const [navigateToReviewAndSubmit, set_navigateToReviewAndSubmit] = useState(false);
    const [navigateToDraw, set_navigateToDraw] = useState(false);

    useEffect(() => {
        if (navigateToReviewAndSubmit) navigate(`/mobilereviewandsubmit/${dashboardDrawBudget.drawBudgetId}`);
    }, [navigateToReviewAndSubmit]);

    useEffect(() => {
        if (navigateToDraw) navigate(`/draw/${dashboardDrawBudget.drawBudgetId}`);
    }, [navigateToDraw]);

    const addressLinkText = () => {
        if (isMobileScreen() && dashboardDrawBudget.borrowerSubmitted && dashboardDrawBudget.canAddDraw === false) {
            set_navigateToReviewAndSubmit(true);
            return;
        }

        if (dashboardDrawBudget.canAddDraw) {
            set_modalDashboarDrawBudget(dashboardDrawBudget);
        } else {
            set_navigateToDraw(true);
            return;
        }
    };

    const shortAddress = dashboardDrawBudget.address.replace(/, *[^,]+$/, '');
    return (
        <div className='address'>
            <a onClick={addressLinkText}>{shortAddress}</a>
        </div>
    );
};
